export default __webpack_public_path__ + "static/media/actualites.4e5b4919.png";